// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 991 ? "52774a7f" : chunkId) + "." + {"991":"396dc3dbc647afd2","5205":"991827d361c4f3b3","9819":"399a75f0e536ab1c"}[chunkId] + ".js";
};